import { useState, useEffect } from 'react';
import { useMondaySDK } from './hooks/useMondaySDK';
import SettingsPage from './components/SettingsPage';
import './App.css';

/**
 * Main application component for Monday.com app settings
 *
 * @returns {JSX.Element} The main application component
 */
function App(): JSX.Element {
  const { isInitialized } = useMondaySDK();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isInitialized) {
      setIsLoading(false);
    }
  }, [isInitialized]);

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner" />
        <p>Initializing Monday.com app...</p>
      </div>
    );
  }

  return (
    <div className="app-container">
      <SettingsPage />
    </div>
  );
}

export default App;
